import React, { useState, useContext, useEffect } from "react";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import AddNewMenuCard from "../../components/menu/MenuCard/AddNewMenuCard";
import MenuCard from "../../components/menu/MenuCard/MenuCard";
import MenuBar from "../../components/menu/MenuBar/MenuBar";
import { AuthContext } from "../../AuthContext";
import { useHistory } from "react-router-dom";

export default function Menu() {
	const [currentCategory, setCurrentCategory] = useState("Todos");
	const {
		databasesRef: { menuDB, parentMenuDB },
	} = useContext(AuthContext);
	const [menu, setMenu] = useState([]);
	const [categories, setCategories] = useState([]);

	let history = useHistory();

	const categoryHandler = (newCategory) => {
		if (newCategory === "addCategory") {
			history.push("/categories");
		} else {
			setCurrentCategory(newCategory.name);
		}
	};

	useEffect(() => {
		if (menuDB) {
			const menuListener = menuDB.onSnapshot((querySnapshot) => {
				let menuData = [];
				querySnapshot.forEach((doc) => (menuData = [...menuData, { data: doc.data(), id: doc.id }]));
				menuData.sort((a, b) => {
					const positionA = a.data.position || 9999999;
					const positionB = b.data.position || 9999999;
					return positionA > positionB ? 1 : -1;
				});
				setMenu(menuData);
			});

			return menuListener;
		}
	}, [menuDB]);

	useEffect(() => {
		if (parentMenuDB) {
			const categoriesListener = parentMenuDB.onSnapshot((doc) => {
				const data = doc.data();
				setCategories(data?.categories || []);
			});
			return categoriesListener;
		}
	}, [parentMenuDB]);

	return (
		<Container style={{ padding: "1em" }}>
			<MenuBar categoryHandler={categoryHandler} categories={categories} />
			<Grid container spacing={1}>
				<Grid item lg={3} md={4}>
					<AddNewMenuCard />
				</Grid>
				{menu
					.filter(({ data }) => currentCategory === "Todos" || data.category === currentCategory)
					.map(({ data, id }, index) => (
						<Grid key={`${index}Menu`} item lg={3} md={4}>
							<MenuCard data={data} id={id} db={menuDB} />
						</Grid>
					))}
			</Grid>
		</Container>
	);
}
